import { Component, OnInit, ViewChild, ElementRef, HostListener, computed } from '@angular/core';
import { AuthService } from '../../../../services/auth.service';
import { Enums } from '../../../../shared/enums';
import { IMPORTS } from './_imports';

@Component({
    selector: 'main-menu',
    templateUrl: './main-menu.component.html',
    styleUrl: './main-menu.component.scss',
    standalone: true,
    imports: IMPORTS
})
export class MainMenuComponent implements OnInit {
    // #region [ViewChild]
    @ViewChild('dropdownMenuRef') dropdownMenuRef: ElementRef;
    @ViewChild('headerButtonRef') headerButtonRef: ElementRef;
    // #endregion

    // #region [listeners]
    @HostListener('document:click', ['$event'])
    clickout(event) {
        if (this.dropdownMenuRef?.nativeElement?.classList.contains('show')) {
            if (!event.composedPath().includes(this.dropdownMenuRef.nativeElement)) {
                this.toggleMenu();
            }
        } else {
            if (event.composedPath().includes(this.headerButtonRef?.nativeElement)) {
                this.toggleMenu();
            }
        }
    }
    // #endregion

    // #region [Type props]
    Enums = Enums;
    // #endregion

    // #region [props]
    $currentUser = computed(() => this.authService.$user());
    $isOwner = computed(() => this.$currentUser()?.perfis.includes(Enums.Profiles.Owner));
    // #endregion

    constructor(
        private elementRef: ElementRef,
        public authService: AuthService
    ) { }

    ngOnInit() { }

    toggleMenu() {
        this.dropdownMenuRef.nativeElement.classList.toggle('show');
    }

    // #region [===== private methods =====]
    // #endregion
}
